(function () {
	const initProductAccordion = () => {
		const $accordionTitles = $(".about__accordion-title");
		$accordionTitles.off("click");

		$(".about__accordion-item.active")
			.find(".about__accordion-title")
			.addClass("active")
			.siblings(".about__accordion-description")
			.show();

		$accordionTitles.on("click", function () {
			const $this = $(this);
			const isActive = $this.hasClass("active");
			$accordionTitles.removeClass("active")
				.siblings(".about__accordion-description").slideUp(300);
			if (!isActive) {
				$this.addClass("active")
					.siblings(".about__accordion-description").slideDown(300);
			}
		});
	};
	document.addEventListener("shopify:section:load", initProductAccordion);
	initProductAccordion();
})();
